var version = '6.2.0';

module.exports = version;
